import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Menu = () => {
  const location = useLocation();
  const dashboardPaths = ['/admin/dashboard1', '/admin/dashboard2', '/admin/dashboard3'];
  const masterPaths = ['/admin/student', '/admin/coaches', '/admin/staff'];
  const studyPaths = ['/admin/principle', '/admin/book'];
  const sessionPaths = ['/admin/session', '/admin/attendance'];
  

  const isActive = (path) => location.pathname === path;
  const isDashboardRoute = dashboardPaths.includes(location.pathname);
  const isMasterRoute = masterPaths.includes(location.pathname);
  const isStudyRoute = studyPaths.includes(location.pathname);
  const isSessionRoute = sessionPaths.includes(location.pathname);

  const [isDashboardOpen, setIsDashboardOpen] = useState(false);
  const [isMasterOpen, setIsMasterOpen] = useState(false);
  const [isStudyOpen, setIsStudyOpen] = useState(false);
  const [isSessionOpen, setIsSessionOpen] = useState(false);

  // Auto-open if current route is a dashboard path
  useEffect(() => {
    if (isDashboardRoute) {
      setIsDashboardOpen(true);
    }
    if (isMasterRoute) {
      setIsMasterOpen(true);
    }
    if (isStudyRoute) {
      setIsStudyOpen(true);
    }
    if (isSessionRoute) {
      setIsSessionOpen(true);
    }
  }, [location.pathname]);

  const toggleDashboardMenu = () => {
    setIsDashboardOpen((prev) => !prev);
  };

  const toggleMasterMenu = () => {
    setIsMasterOpen((prev) => !prev);
  };
  const toggleStudyMenu = () => {
    setIsStudyOpen((prev) => !prev);
  };
  const toggleSessionMenu = () => {
    setIsSessionOpen((prev) => !prev);
  };
  return (
    <aside className="main-sidebar sidebar-dark-primary elevation-4">
      <Link to="/" className="brand-link">
        <img
          src="/images/pawn.png"
          alt="AdminLTE Logo"
          className="brand-image img-circle elevation-3"
          style={{ opacity: '.8' }}
        />
        <span className="brand-text font-weight-light">Aadhav Academy</span>
      </Link>

      <div className="sidebar">
        <div className="user-panel mt-3 pb-3 mb-3 d-flex">
          <div className="image">
            <img
              src="/images/user.png"
              className="img-circle elevation-2"
              alt="User"
            />
          </div>
          <div className="info">
            <Link to="#" className="d-block">Aadhav</Link>
          </div>
        </div>

        <nav className="mt-2">
          <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
            {/* Dashboard Menu */}
            <li className={`nav-item ${isDashboardOpen ? 'menu-open' : ''}`}>
              <a
                href="#"
                className={`nav-link ${isDashboardRoute ? 'active' : ''}`}
                onClick={(e) => {
                  e.preventDefault();
                  toggleDashboardMenu();
                }}
              >
                <i className="nav-icon fas fa-tachometer-alt" />
                <p>
                  Dashboard
                  <i className="right fas fa-angle-left" />
                </p>
              </a>
              <ul className="nav nav-treeview">
                <li className="nav-item">
                  <Link to="/admin/dashboard1" className={`nav-link ${isActive('/admin/dashboard1') ? 'active' : ''}`}>
                    <i className="far fa-circle nav-icon" />
                    <p>Dashboard v1</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/admin/dashboard2" className={`nav-link ${isActive('/admin/dashboard2') ? 'active' : ''}`}>
                    <i className="far fa-circle nav-icon" />
                    <p>Dashboard v2</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/admin/dashboard3" className={`nav-link ${isActive('/admin/dashboard3') ? 'active' : ''}`}>
                    <i className="far fa-circle nav-icon" />
                    <p>Dashboard v3</p>
                  </Link>
                </li>
              </ul>
            </li>

            {/* Master Menu */}
            <li className={`nav-item ${isMasterOpen ? 'menu-open' : ''}`}>
              <a
                href="#"
                className={`nav-link ${isMasterRoute ? 'active' : ''}`}
                onClick={(e) => {
                  e.preventDefault();
                  toggleMasterMenu(); // Corrected to toggle Master menu
                }}
              >
                <i className="nav-icon fas fa-cogs" />
                <p>
                  Master
                  <i className="right fas fa-angle-left" />
                </p>
              </a>
              <ul className="nav nav-treeview">
                <li className="nav-item">
                  <Link to="/admin/student" className={`nav-link ${isActive('/admin/student') ? 'active' : ''}`}>
                    <i className="far fa-circle nav-icon" />
                    <p>Student</p>
                  </Link>
                </li>
                <li className="nav-item">
                <Link to="/admin/coaches" className={`nav-link ${isActive('/admin/coaches') ? 'active' : ''}`}>
                <i className="far fa-circle nav-icon" />
                <p>Coaches</p>
              </Link>

                </li>
                <li className="nav-item">
                  <Link to="/admin/staff" className={`nav-link ${isActive('/admin/staff') ? 'active' : ''}`}>
                    <i className="far fa-circle nav-icon" />
                    <p>Staff</p>
                  </Link>
                </li>
              </ul>
            </li>
            
            {/* Master Menu */}
            <li className={`nav-item ${isStudyOpen ? 'menu-open' : ''}`}>
              <a
                href="#"
                className={`nav-link ${isStudyRoute ? 'active' : ''}`}
                onClick={(e) => {
                  e.preventDefault();
                  toggleStudyMenu(); // Corrected to toggle Master menu
                }}
              >
                <i className="nav-icon fas fa-cogs" />
                <p>
                  Study
                  <i className="right fas fa-angle-left" />
                </p>
              </a>
              <ul className="nav nav-treeview">
                <li className="nav-item">
                  <Link to="/admin/principle" className={`nav-link ${isActive('/admin/principle') ? 'active' : ''}`}>
                    <i className="far fa-circle nav-icon" />
                    <p>Principle</p>
                  </Link>
                </li>
                <li className="nav-item">
                <Link to="/admin/book" className={`nav-link ${isActive('/admin/book') ? 'active' : ''}`}>
                <i className="far fa-circle nav-icon" />
                <p>Books</p>
              </Link>
                </li>
              </ul>
            </li>

                 {/* Session Menu */}
            <li className={`nav-item ${isSessionOpen ? 'menu-open' : ''}`}>
              <a
                href="#"
                className={`nav-link ${isSessionRoute ? 'active' : ''}`}
                onClick={(e) => {
                  e.preventDefault();
                  toggleSessionMenu(); // Corrected to toggle Master menu
                }}
              >
                <i className="nav-icon fas fa-cogs" />
                <p>
                  Session
                  <i className="right fas fa-angle-left" />
                </p>
              </a>
              <ul className="nav nav-treeview">
                <li className="nav-item">
                  <Link to="/admin/session" className={`nav-link ${isActive('/admin/session') ? 'active' : ''}`}>
                    <i className="far fa-circle nav-icon" />
                    <p>Session</p>
                  </Link>
                </li>
                <li className="nav-item">
                <Link to="/admin/attendance" className={`nav-link ${isActive('/admin/attendance') ? 'active' : ''}`}>
                <i className="far fa-circle nav-icon" />
                <p>Attendance</p>
              </Link>
                </li>
              </ul>
            </li>

          </ul>
        </nav>
      </div>
    </aside>
  );
};

export default Menu;
